// removed by extract-text-webpack-plugin
module.exports = {"testimonial-editor":"style__testimonial-editor___JjKNS","testimonial-button-panel":"style__testimonial-button-panel___xjl7P","testimonial-button":"style__testimonial-button___3NtlS"};


//////////////////
// WEBPACK FOOTER
// ./components/TestimonialForm/style.scss
// module id = 1348
// module chunks = 0